// extracted by mini-css-extract-plugin
export default {"primaryScrollbar":"HHHO5LCi6sVRtYeKH35K"};